//Built-in libraries

//Third party libraries

//Custom components
import { Accordion, AccordionItem } from 'components/UI/Accordion';
import ReviewCard from './ReviewCard';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous
import { formatPhoneNumber } from 'utils';

//Component Begin

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();
  const { step1, step2, step3, step4, step5 } = data;

  return (
    <div className={`space-y-5 px-6 py-4 lg:col-span-9`}>
      <ReviewCard title='Information' handleEdit={() => setCurrentStep(1)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Name</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.name}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Street Address
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.streetAddress}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Submitter</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.submitter}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Submitter Title
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.submitterTitle}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              +1 {formatPhoneNumber(step1.phone)}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Fax</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.fax ? `+1 ${formatPhoneNumber(step1.fax)}` : 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Email</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step1.email}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard
        title='Organization Documents'
        handleEdit={() => setCurrentStep(2)}
      >
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Articles of Incorporation
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step2.f1.selectedFiles.length > 0
                ? step2.f1.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Charter</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step2.f2.selectedFiles.length > 0
                ? step2.f2.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Certificate of Good Standing
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step2.f3.selectedFiles.length > 0
                ? step2.f3.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Map of Service Area
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step2.f4.selectedFiles.length > 0
                ? step2.f4.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Legal Status' handleEdit={() => setCurrentStep(3)}>
        <dl>
          <div className='bg-white px-6 py-4'>
            <h3 className='text-sm font-semibold text-gray-500'>
              What document clearly defines your geographic service area?
            </h3>
          </div>
          {!step3.section1.doesDocumentDefines && (
            <dd className='bg-white px-6 mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              None
            </dd>
          )}
          {step3.section1.doesDocumentDefines === 'articlesOfIncorporation' && (
            <>
              <div className='bg-white'>
                <Accordion>
                  <div className='px-6 py-4 space-y-4'>
                    <div className='bg-white'>
                      <AccordionItem
                        id='articlesOfIncorporation'
                        title={<span>Article of Incorporation</span>}
                      >
                        <dl className='grid grid-cols-12'>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Section
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.articlesOfIncorporation.section}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Page
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.articlesOfIncorporation.page}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Paragraph
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.articlesOfIncorporation.paragraph}
                            </dd>
                          </div>
                        </dl>
                      </AccordionItem>
                    </div>
                  </div>
                </Accordion>
              </div>
            </>
          )}
          {step3.section1.doesDocumentDefines === 'byLaws' && (
            <>
              <div className='bg-white'>
                <Accordion>
                  <div className='px-6 py-4 space-y-4'>
                    <div className='bg-white'>
                      <AccordionItem id='byLaws' title={<span>By Laws</span>}>
                        <dl className='grid grid-cols-12'>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Page
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.byLaws.page}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Paragraph
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.byLaws.paragraph}
                            </dd>
                          </div>
                        </dl>
                      </AccordionItem>
                    </div>
                  </div>
                </Accordion>
              </div>
            </>
          )}
          {step3.section1.doesDocumentDefines === 'charter' && (
            <>
              <div className='bg-white'>
                <Accordion>
                  <div className='px-6 py-4 space-y-4'>
                    <div className='bg-white'>
                      <AccordionItem id='charter' title={<span>Charter</span>}>
                        <dl className='grid grid-cols-12'>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Page
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.charter.page}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Paragraph
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {step3.section1.charter.paragraph}
                            </dd>
                          </div>
                        </dl>
                      </AccordionItem>
                    </div>
                  </div>
                </Accordion>
              </div>
            </>
          )}
          {step3.section1.doesDocumentDefines === 'gap' && (
            <>
              <div className='px-6 py-4 text-sm font-semibold text-gray-500'>
                <span>Gap</span>
              </div>
            </>
          )}
          <div className='bg-gray-50 px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Notarized certificate that By-Laws, as provided are accurate
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step3.f1.selectedFiles.length > 0
                ? step3.f1.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Please provide documentation of your tax exemption ruling from the
              Internal Revenue Service (IRS) under Section 501(c)(3) or (4) of
              the Internal Revenue Code of 1986
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step3.f2.selectedFiles.length > 0
                ? step3.f2.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard
        title='Organization Structure'
        handleEdit={() => setCurrentStep(4)}
      >
        <dl>
          <div className='bg-white px-6 py-2'>
            <h2 className='text-sm font-bold text-gray-500'>
              Please indicate which document confirm that maintains at least
              one-third of its governing board's membership for:
            </h2>
            <ul className='text-sm list-disc ml-4 font-bold text-gray-500'>
              <li>residents of low-income neighborhoods, or </li>
              <li>other low-income community residents, or </li>
              <li>
                elected representatives of low-income neighborhood organizations
              </li>
            </ul>
          </div>
          {!step4.section1.q1 && (
            <dd className='bg-white px-6 py-1 pt-3 text-sm text-gray-900'>
              None
            </dd>
          )}
          {step4.section1.q1 === 'articlesOfIncorporation' && (
            <>
              <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                Article of Incorporation
              </h3>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Section</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.articlesOfIncorporation.section}
                </dd>
              </div>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Page</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.articlesOfIncorporation.page}
                </dd>
              </div>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Paragraph</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.articlesOfIncorporation.paragraph}
                </dd>
              </div>
            </>
          )}
          {step4.section1.q1 === 'byLaws' && (
            <>
              <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                By-Laws
              </h3>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Page</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.byLaws.page}
                </dd>
              </div>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Paragraph</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.byLaws.paragraph}
                </dd>
              </div>
            </>
          )}
          {step4.section1.q1 === 'charter' && (
            <>
              <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                Charter
              </h3>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Page</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.charter.page}
                </dd>
              </div>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Paragraph</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step4.section1.charter.paragraph}
                </dd>
              </div>
            </>
          )}
          <div className='bg-gray-50 py-4'>
            <h2 className='px-6 text-sm font-bold text-gray-500'>
              Provide documentation evidencing that the CHDO provides a formal
              process for low-income, program beneficiaries to advise the
              organization in all of its decisions regarding the design, siting,
              development, and management of affordable housing projects
            </h2>
            {!step4.providedEvidence && (
              <dd className='px-6 mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                None
              </dd>
            )}
            {step4.providedEvidence === 'byLaws' && (
              <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium col-span-3 text-gray-500'>
                  By Laws
                </dt>
                {step4.f1.selectedFiles.length > 0
                  ? step4.f1.selectedFiles.map((file: any) => {
                      return (
                        <>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {file.name}
                          </dd>
                        </>
                      );
                    })
                  : 'None'}
              </div>
            )}
            {step4.providedEvidence === 'resolutions' && (
              <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium col-span-3 text-gray-500'>
                  Resolutions
                </dt>
                {step4.f2.selectedFiles.length > 0
                  ? step4.f2.selectedFiles.map((file: any) => {
                      return (
                        <>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {file.name}
                          </dd>
                        </>
                      );
                    })
                  : 'None'}
              </div>
            )}
            {step4.providedEvidence === 'writtenStatement' && (
              <>
                <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                  <dt className='text-sm font-medium col-span-3 text-gray-500'>
                    Written Statement
                  </dt>
                  {step4.f3.selectedFiles.length > 0
                    ? step4.f3.selectedFiles.map((file: any) => {
                        return (
                          <>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {file.name}
                            </dd>
                          </>
                        );
                      })
                    : 'No files'}
                </div>
                <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                  <dt className='text-sm font-medium text-gray-500'>Section</dt>
                  <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                    {step4.f3.section}
                  </dd>
                </div>
                <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                  <dt className='text-sm font-medium text-gray-500'>Page</dt>
                  <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                    {step4.f3.page}
                  </dd>
                </div>
                <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                  <dt className='text-sm font-medium text-gray-500'>
                    Paragraph
                  </dt>
                  <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                    {step4.f3.paragraph}
                  </dd>
                </div>
              </>
            )}
          </div>
          <div className='bg-white'>
            <h3 className='px-6 pt-4 text-sm font-bold text-gray-500'>
              Is the CHDO chartered by a state or local government?
            </h3>
            <dd className='px-6 py-4 mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step4.section2.isChartered === 'yes' ? (
                <>
                  {step4.section2.q1 === 'articlesOfIncorporation' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        Article of Incorporation
                      </h3>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Section
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.articlesOfIncorporation.section}
                        </dd>
                      </div>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.articlesOfIncorporation.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.articlesOfIncorporation.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                  {step4.section2.q1 === 'byLaws' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        By-Laws
                      </h3>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.byLaws.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.byLaws.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                  {step4.section2.q1 === 'charter' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        Charter
                      </h3>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.charter.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section2.charter.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                </>
              ) : (
                'No'
              )}
            </dd>
          </div>
          <div className='bg-gray-50'>
            <h3 className='px-6 pt-4 text-sm font-bold text-gray-500'>
              Is CHDO sponsored or created by a for-profit?
            </h3>
            <dd className='px-6 py-4 mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step4.section3.isSponsored === 'yes' ? (
                <>
                  {step4.section3.q3 === 'articlesOfIncorporation' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        Article of Incorporation
                      </h3>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Section
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.articlesOfIncorporation.section}
                        </dd>
                      </div>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.articlesOfIncorporation.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.articlesOfIncorporation.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                  {step4.section3.q3 === 'byLaws' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        By-Laws
                      </h3>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.byLaws.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.byLaws.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                  {step4.section3.q3 === 'charter' && (
                    <>
                      <h3 className='px-6 py-4 text-sm font-semibold text-gray-500'>
                        Charter
                      </h3>
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Page
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.charter.page}
                        </dd>
                      </div>
                      <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-gray-500'>
                          Paragraph
                        </dt>
                        <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                          {step4.section3.charter.paragraph}
                        </dd>
                      </div>
                    </>
                  )}
                </>
              ) : (
                'No'
              )}
            </dd>
          </div>
          <div className='bg-white py-4'>
            <h3 className='px-6 text-sm font-bold text-gray-500'>
              List of Board Members
            </h3>
            {step4.boardMembers.length > 0 && (
              <Accordion multi>
                <div className='px-6 py-4 space-y-4'>
                  {step4.boardMembers.map((member: any) => (
                    <div key={member.id} id={member.id} className='bg-white'>
                      <AccordionItem
                        id={member.id}
                        title={
                          <>
                            <span>{member.name}</span>
                          </>
                        }
                      >
                        <dl className='grid grid-cols-12'>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Name
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {member.name}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Company Name
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {member.company}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Email
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {member.email}
                            </dd>
                          </div>
                        </dl>
                      </AccordionItem>
                    </div>
                  ))}
                </div>
              </Accordion>
            )}
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Capacity' handleEdit={() => setCurrentStep(5)}>
        <dl>
          <div className='bg-white py-4'>
            <h3 className='bg-white px-6 text-sm font-bold text-gray-500'>
              Provide evidence that your CHDO conforms to the financial
              accountability standards of 24 CFR 84.21, "Standards for Financial
              Management Systems"
            </h3>
          </div>
          <div className='bg-gray-50 px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Notarized statement
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step5.f1.selectedFiles.length > 0
                ? step5.f1.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Certification from a CPA
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step5.f2.selectedFiles.length > 0
                ? step5.f2.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              HUD approved audit summary
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step5.f3.selectedFiles.length > 0
                ? step5.f3.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Identify fiscal year
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step5.fiscalYear}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Are you in compliance with all DOH or CHFA agreements?
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {step5.hasCompliance === 'yes' ? 'Yes' : 'No'}
            </dd>
          </div>
          <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Please provide evidence that you have demonstrated capacity and
              experience to act as a developer/ owner/ sponsor and carry out the
              proposed development activity to be assisted with HOME funds
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step5.f4.selectedFiles.length > 0
                ? step5.f4.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50'>
            <h3 className='px-6 text-sm font-semibold text-gray-500 mt-2'>
              List of Organization Staffs
            </h3>
            {step5.staffs.length > 0 && (
              <Accordion multi>
                <div className='px-6 py-6 space-y-4'>
                  {step5.staffs.map((staff: any) => (
                    <div key={staff.id} id={staff.id} className='bg-white'>
                      <AccordionItem
                        id={staff.id}
                        title={
                          <>
                            <span>{staff.name}</span>
                          </>
                        }
                      >
                        <dl className='grid grid-cols-12'>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Name
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {staff.name}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Title
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {staff.title}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              Duty
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {staff.duties}
                            </dd>
                          </div>
                          <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-gray-500'>
                              No of Service Years
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                              {staff.noOfServiceYears}
                            </dd>
                          </div>
                        </dl>
                      </AccordionItem>
                    </div>
                  ))}
                </div>
              </Accordion>
            )}
          </div>
          <div className='bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Submit evidence of staff training
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex fle-col'>
              {step5.f5.selectedFiles.length > 0
                ? step5.f5.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              The CHDO or its parent organization must be able to show one year
              of serving the community prior to the date the Participating
              Jurisdiction provides HOME funds to the organization. The
              organization must describe its history (or its parent
              organization's history) of serving the community by submitting a
              narrative describing activities which it provided (or its parent
              organization provided), such as developing new housing,
              rehabilitating existing stock and managing housing stock, or
              delivering non-housing services that have had lasting benefits for
              the community, such as counseling, food relief, or childcare
              facilities. The narrative must demonstrate that the CHDO has a
              history of serving the community within which housing to be
              assisted with HOME funds is to be located, as evidenced by
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col'>
              {step5.f6.selectedFiles.length > 0
                ? step5.f6.selectedFiles.map((file: any) => {
                    return <span>{file.name}</span>;
                  })
                : 'None'}
            </dd>
            {step5.f6.description && (
              <>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {step5.f6.description}
                </dd>
              </>
            )}
          </div>
        </dl>
      </ReviewCard>
    </div>
  );
}
